export const ROLES = ['ADMIN', 'SUPERVISOR', 'COUNTER', 'AUDITOR'] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABEL: Record<Role, string> = {
  ADMIN: 'Admin',
  SUPERVISOR: 'Supervisor (Cost)',
  COUNTER: 'Counter',
  AUDITOR: 'Auditor',
};

/** Permission matrix from Requirements v2 §10. The API enforces these; the web only uses them to hide UI. */
export const PERMISSIONS = {
  'users.manage': ['ADMIN'],
  'master.import': ['ADMIN', 'SUPERVISOR'],
  'warehouses.manage': ['ADMIN', 'SUPERVISOR'],
  'barcodes.manage': ['ADMIN', 'SUPERVISOR'],
  'barcodes.bindWhileCounting': ['ADMIN', 'SUPERVISOR', 'COUNTER'],
  'barcodes.view': ['ADMIN', 'SUPERVISOR', 'AUDITOR'],
  'sessions.manage': ['ADMIN', 'SUPERVISOR'],
  'sessions.reopen': ['ADMIN'],
  'count.scan': ['ADMIN', 'SUPERVISOR', 'COUNTER'],
  'entries.voidAny': ['ADMIN', 'SUPERVISOR'],
  'reports.view': ['ADMIN', 'SUPERVISOR', 'COUNTER', 'AUDITOR'],
  'audit.view': ['ADMIN', 'SUPERVISOR', 'AUDITOR'],
  'master.sync': ['ADMIN', 'SUPERVISOR', 'COUNTER'],
} as const satisfies Record<string, readonly Role[]>;

export type Permission = keyof typeof PERMISSIONS;

export function can(role: Role | undefined | null, permission: Permission): boolean {
  return !!role && (PERMISSIONS[permission] as readonly Role[]).includes(role);
}
